import FTPlayerOptions from '../ft-player-options';
import { addEvent } from '../utils/events';
import { HAS_MSE, loadScript } from '../utils/general';
import { isDashSource } from '../utils/media';
import Native from './native';

class DashMedia extends Native {

  static player = null;

  player!:DashMedia;

  events = null;

  options = {};
  startTime = 0;

  constructor(videoEl:HTMLVideoElement, mediaSource:any, options:FTPlayerOptions, startTime:number) {
    super(videoEl, mediaSource);
    this.options = options;
    this.startTime = startTime;

    function createInstance() {
      this.player = DashMedia.player || dashjs.MediaPlayer().create();
    }
    this.promise = (typeof dashjs === 'undefined') ?
      // Ever-green script
      loadScript(platformSettings.path + 'modules/dashjs/dash.all.min.js') :
      new Promise(resolve => resolve(true));

    this.promise.then(createInstance.bind(this));
    return this;
  }

  canPlayType(mimeType) {
    return HAS_MSE && mimeType === 'application/dash+xml';
  }

  load() {
    this._preparePlayer();
    this.player.attachSource(this.media.src);

    // const e = addEvent('loadedmetadata');
    // this.videoEl.dispatchEvent(e);

    if (!this.events) {
      this.events = dashjs.MediaPlayer.events;
      Object.keys(this.events).forEach(event => {
        this.player.on(this.events[event], this._assign.bind(this));
      });
    }
  }

  destroy() {
    this._revoke();
  }

  set src(media) {
    if (isDashSource(media)) {
      this._revoke();
      this.player = dashjs.MediaPlayer().create();
      //this._preparePlayer();
      //this.player.attachSource(media.src);

      this.events = dashjs.MediaPlayer.events;
      Object.keys(this.events).forEach(event => {
        this.player.on(this.events[event], this._assign.bind(this));
      });
    }
  }

  get levels() {
    const levels = [];
    if (this.player) {
      const bitrates = this.player.getBitrateInfoListFor('video');
      if (bitrates.length) {
        bitrates.forEach((item) => {
          if (bitrates[item]) {
            const { height, name } = bitrates[item];
            const level = {
              height,
              id: item,
              label: name || null,
            };
            levels.push(level);
          }
        });
      }
    }
    return levels;
  }

  set level(level) {
    if (level === 0) {
      this.player.setAutoSwitchQuality(true);
    } else {
      this.player.setAutoSwitchQuality(false);
      this.player.setQualityFor('video', level);
    }
  }

  get level() {
    return this.player ? this.player.getQualityFor('video') : -1;
  }

  _assign(event) {
    if (event.type === 'error') {
      const details = {
        detail: {
          type: 'M(PEG)-DASH',
          message: event,
        },
      };
      const errorEvent = addEvent('playererror', details);
      this.videoEl.dispatchEvent(errorEvent);
    } else {
      //console.log('[ft-streaming-player] : ' + event.type);
      const e = addEvent(event.type, event);
      if (event.type == 'playbackMetaDataLoaded') {
        if (this.startTime > 0) {
          this.videoEl.currentTime = this.startTime;
        }
        //this.videoEl.play()
      }
      this.videoEl.dispatchEvent(e);
    }
  }

  _revoke() {
    if (this.events) {
      Object.keys(this.events).forEach(event => {
        this.player.off(this.events[event], this._assign.bind(this));
      });
      this.events = null;
    }
    this.player.reset()
  }

  _preparePlayer() {
    // In version 3x, `getDebug` is deprecated
    //if (typeof this.player.getDebug().setLogToBrowserConsole === 'undefined') {
    this.player.updateSettings({
      debug: {
        logLevel: dashjs.Debug.LOG_LEVEL_NONE,
      },
      streaming: {
        buffer: {
          fastSwitchEnabled: true,
          bufferPruningInterval: 10,
          bufferToKeep: 20,
          bufferTimeAtTopQuality: 10,
          bufferTimeAtTopQualityLongForm: 15,
          stableBufferTime: 8,
          minBufferTime: 4,
          initialBufferLevel: 6
        },
        scheduling: {
          scheduleWhilePaused: false
        }
      },
    });

    this.player.initialize(this.videoEl, this.media.src, true);

    // If DRM is set, load protection data
    if (this.options && typeof this.options.drm === 'object' && Object.keys(this.options.drm).length) {
      this.player.setProtectionData(this.options.drm);
      if (this.options.robustnessLevel && this.options.robustnessLevel) {
        this.player.getProtectionController().setRobustnessLevel(this.options.robustnessLevel);
      }
    }
  }
}

export default DashMedia;
